var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#582483",
    width: "24px",
    height: "24px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6,19.4h-7.3c1-1.5,1.6-3.2,1.8-5c0.6-5.8-2.5-11-7.6-13.2c-4.8-2.1-10.1-1.2-14,2.2l-9.2,8.3c-1.8-2-4.4-3.2-7.2-3.2 c-2.9,0-5.4,1.2-7.2,3.2l-9.2-8.4c-3.9-3.5-9.2-4.4-14-2.2c-5.2,2.3-8.2,7.5-7.6,13.2c0.2,1.8,0.8,3.5,1.8,5H6.5 C2.9,19.4,0,22.3,0,26v9.8C0,37.6,1.5,39,3.3,39h93.6c1.8,0,3.3-1.5,3.3-3.3V26C100.2,22.3,97.3,19.4,93.6,19.4z M70.8,8.4 c1.7-1.5,4-2.2,6.2-1.6c3.1,0.9,4.9,3.6,4.7,6.7c-0.2,3.4-3.3,5.9-6.7,5.9h-15v-1.1c0,0,0-0.1,0-0.1C62.4,16,67.8,11,70.8,8.4z  M18.7,11.4c0.4-1.9,1.8-3.4,3.5-4.3c2.4-1.1,5-0.7,7,1.1l11,10c0,0,0,0.1,0,0.1v1.1H24.9C20.9,19.4,17.7,15.6,18.7,11.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,93.5c0,3.6,2.9,6.5,6.5,6.5h30.5V45.6h-37V93.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6,100h30.5c3.6,0,6.5-2.9,6.5-6.5V45.6h-37V100z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.e8784877d123900b65edfebeee80269c.svg";
export { ForwardRef as ReactComponent };